import React from 'react';

import { Slider } from '@atlas/components';

const TopEventsListLoader = () => {
  const sportsItemSkeleton = i => (
    <Slider.Slide key={i}>
      <div className="sports-slider-item-container">
        <div className="sports-slider-item skeleton-bg" />
      </div>
    </Slider.Slide>
  );
  const sportsListSkeleton = [];
  for (let i = 0; i < 10; i++) {
    sportsListSkeleton.push(sportsItemSkeleton(i));
  }

  const sliderConfig = React.useMemo(
    () => ({
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      centeredSlides: true,
    }),
    [],
  );

  return (
    <div className="sports-slider-container">
      <Slider {...sliderConfig}>
        {sportsListSkeleton}
      </Slider>
    </div>
  );
};

export default TopEventsListLoader;
